<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Ændr bemærkningen</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Bemærkning</mat-label>
        <textarea formControlName="remark" rows="4" matInput></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
<div>
  <div mat-dialog-actions class="row-reverse">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
    <button class="modal-cancel" (click)="cancel()" mat-raised-button>Fortryd</button>
  </div>
</div>
